export default "__VITE_ASSET__BixLwspq__"